export enum Env {
    ApiBaseUrl = 'API_BASE_URL',
    VinBaseUrl = 'VIN_BASE_URL',
    OcrBaseUrl = 'OCR_BASE_URL',
    SamlLoginUrl = 'SAML_LOGIN_URL',
    FirebaseApiKey = 'FIREBASE_API_KEY',
    FirebaseProjectId = 'FIREBASE_PROJECT_ID',
    FirebaseMessagingSenderId = 'FIREBASE_MESSAGING_SENDER_ID',
    FirebaseAppId = 'FIREBASE_APP_ID',
    FirebaseVapidKey = 'FIREBASE_VAPID_KEY',
    GtmAuth = 'GTM_AUTH',
    GtmContainerId = 'GTM_ID',
    GtmEnabled = 'GTM_ENABLED',
    GtmPreview = 'GTM_PREVIEW',
    EnableDebugger = 'ENABLE_DEBUGGER',
    DebugApiUtils = 'DEBUG_API_UTILS',
    DebugAvailableEnvironments = 'DEBUG_AVAILABLE_ENVIRONMENTS',
    DebugUserSwitcher = 'DEBUG_USER_SWITCHER',
    amplitudeApiKey = 'AMPLITUDE_API_KEY',
    NutrientApiKey = 'NUTRIENT_WEB_SDK_LICENSE_KEY',
    NutrientAndroidApiKey = 'NUTRIENT_ANDROID_SDK_LICENSE_KEY',
    NutrientIosApiKey = 'NUTRIENT_IOS_SDK_LICENSE_KEY',
    EvBatteryScan = 'EV_BATTERY_SCAN',
    UnleashClientKey = 'UNLEASH_CLIENT_KEY',
    UnleashUrl = 'UNLEASH_URL',
    WebBaseUrl = 'WEB_BASE_URL',
    SubaruDiagnosticsUrl = 'SUBARU_DIAGNOSTICS_URL',
    LogLevel = 'LOG_LEVEL',
    LogHttpRequests = 'LOG_HTTP_REQUESTS',
    DatadogClientToken = 'DATADOG_CLIENT_TOKEN',
    DatadogSite = 'DATADOG_SITE',
}

export const Constants = {
    AccessTokenHeaderName: 'X-Subcomm-Access-Token',
    RandomErrorProbabilityHeaderName: 'X-Random-Error-Probability',
    RequestIdHeaderName: 'X-Request-Id',
    SimulateDelayHeaderName: 'X-Simulate-Delay',
    Env,
    TechlineSupportPhone: '1-866-782-2782',
    TimeoutPopupDurationInSeconds: 2 * 60,
    RefreshTokenWindowInSeconds: 5 * 60,
};
